export default "__VITE_ASSET__B5BW5wyx__"